import { useLocalizedControl } from "../../model/localized-value-control-context";
import { Fragment } from "react";
import { SupportedLanguages } from "gql/graphql";
import { LocaleFormItem } from "../locale-form-item/locale-form-item";
import { AutoTranslateButton } from "../auto-translate-button/auto-translate-button";
import { useTranslations } from "use-intl";

const LOCALES_LABELS: Record<SupportedLanguages, string> = {
  [SupportedLanguages.En]: "English",
  [SupportedLanguages.Ru]: "Русский",
  [SupportedLanguages.Kz]: "Қазақша",
  [SupportedLanguages.Uz]: "Узбекский",
};

export function FullView() {
  const { languages } = useLocalizedControl();
  const t = useTranslations("LocalizedValue");

  return (
    <>
      <div className="mb-4 flex justify-end">
        <AutoTranslateButton type="primary" iconPosition="end">
          {t("Autotranslate")}
        </AutoTranslateButton>
      </div>

      {languages.map((locale) => {
        return (
          <Fragment key={locale}>
            <LocaleFormItem
              locale={locale}
              label={LOCALES_LABELS[locale]}
              layout="vertical"
            />
          </Fragment>
        );
      })}
    </>
  );
}
